import { http } from "./http";

const ENDPOINTS = {
  INVOICES: "/invoices/",
  INVOICE: (id) => `/invoices/${id}/`,
  INVOICE_MARK_PAID: (id) => `/invoices/${id}/mark_as_paid/`,
  INVOICE_UPDATE_STATUS: (id) => `/invoices/${id}/update_status/`,
  INVOICE_CANCEL: (id) => `/invoices/${id}/invoice_cancellation/`,
  INVOICE_PDF: (id) => `/invoices/${id}/invoice_pdf`,
  INVOICE_OVERDUE: "/invoices/overdue/",
  INVOICE_CREATE: "/invoices/smartbill/factura/",
  INVOICE_LINK: "/invoices/smartbill/link/",
  INVOICE_UNLINK: "/invoices/unlink/",
  INVOICE_VATS: "/invoices/smartbill/vats/"
};

export const invoiceAPI = {
  getAll: () => http.get(ENDPOINTS.INVOICES),
  getById: (id) => http.get(ENDPOINTS.INVOICE(id)),
  create: (invoiceData) => http.post(ENDPOINTS.INVOICES, invoiceData),
  update: (id, invoiceData) => http.patch(ENDPOINTS.INVOICE(id), invoiceData),
  delete: (id) => http.delete(ENDPOINTS.INVOICE(id)),
  mark_as_paid: (id) => http.post(ENDPOINTS.INVOICE_MARK_PAID(id)),
  cancel_invoice: (id) => http.patch(ENDPOINTS.INVOICE_CANCEL(id)),
  get_invoice_pdf: (id) => http.get_pdf(ENDPOINTS.INVOICE_PDF(id)),
  getOverdue: () => http.get(ENDPOINTS.INVOICE_OVERDUE),
  createInvoice: (invoiceData) => http.post(ENDPOINTS.INVOICE_CREATE, invoiceData),
  linkInvoice: (invoiceData) => http.post(ENDPOINTS.INVOICE_LINK, invoiceData),
  unlinkInvoice: (paymentId) => http.post(ENDPOINTS.INVOICE_UNLINK, { payment_id: paymentId }),
  unlinkInvoiceById: (invoiceId) => http.post(ENDPOINTS.INVOICE_UNLINK, { invoice_id: invoiceId }),
  getAccountVats: () => http.get(ENDPOINTS.INVOICE_VATS)
};